export default __webpack_public_path__ + "img/close-x.03cf5b78.svg";